import React, { useContext } from "react";
import { Modal } from "reactstrap";
import { IoClose } from "react-icons/io5";
import { FaTimes } from "react-icons/fa";
import { Language } from "../../App";

export default function BenefitsModal({ isOpen, onClose }) {
  const { lang } = useContext(Language);

  const getSplashData = () => {
    try {
      const splashData = localStorage.getItem("SplashData");
      const parsed = splashData ? JSON.parse(splashData) : null;
      return parsed;
    } catch (error) {
      console.error("Error parsing SplashData:", error);
      return null;
    }
  };

  const splashData = getSplashData();
  const benefits = splashData?.home?.benefit_keys || [];

  const formatBenefitKey = (key) => {
    const langKey = `benefit_${key}`;
    if (lang?.[langKey]) return lang[langKey];
    return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      backdrop="static"
      className="benefits-modal"
    >
      <style>{`
        .benefits-modal .modal-dialog {
          max-width: 420px;
          margin: auto;
          font-family: 'Outfit', sans-serif;
        }
        .benefits-modal .modal-content {
          border: none;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 24px 70px rgba(0,0,0,0.13);
          background: #fff;
        }
        .benefits-header {
          background: #fff;
          padding: 20px;
          border-bottom: 1px solid #ECECEC;
          position: relative;
        }
        .benefits-close-btn {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 32px;
          height: 32px;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #555;
          font-size: 18px;
          background: transparent;
          padding: 0;
        }
        .benefits-title {
          font-size: 18px;
          font-weight: 700;
          color: #0f1419;
          margin: 0;
        }
        .benefits-body {
          padding: 16px 20px;
          max-height: 500px;
          overflow-y: auto;
        }
        .benefits-list {
          display: flex;
          flex-direction: column;
          gap: 0px;
        }
        .msub-feature-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 6px 0;
        }
        .msub-feature-icon {
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .msub-feature-text {
          font-size: 14px;
          font-weight: 500;
          color: #6b7280;
          margin: 0;
        }
      `}</style>

      <div className="benefits-header">
        <button
          className="benefits-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          <IoClose />
        </button>
        <h3 className="benefits-title">
          {lang?.msub_explore_benefits || "Explore Benefits"}
        </h3>
      </div>

      <div className="benefits-body">
        {benefits.length > 0 ? (
          <div className="benefits-list">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="msub-feature-row"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "6px 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flex: 1,
                  }}
                >
                  <div className="msub-feature-icon">
                    <FaTimes
                      size={13}
                      color="#FF2D55"
                      style={{
                        backgroundColor: "#FFE2E2",
                        borderRadius: "50px",
                        padding: "2px",
                      }}
                    />
                  </div>
                  <p className="msub-feature-text">
                    {formatBenefitKey(benefit)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#848798", margin: 0 }}>
            {lang?.msub_no_benefits || "No benefits available"}
          </p>
        )}
      </div>
    </Modal>
  );
}
